module.exports = __webpack_public_path__ + "pc/img/writer_mo_120.68db0db9.png";